export default __webpack_public_path__ + "static/media/geocoder-marker.f4f73138.svg";